export const styles = {
	container: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		position: 'relative',
		zIndex: 1,
		background: 'linear-gradient(180deg, #F1F5FD 0%, #D0DFF4 100%)',
	},
	content: {
		maxWidth: '120rem',
		justifyContent: 'center',
	},
	header: {
		color: 'text.primary',
		fontSize: { lg: '5.5rem', sm: '5.5rem', xs: '3.4rem' },
		fontStyle: 'normal',
		fontWeight: '400',
		margin: '6rem 0 0 0',
		textAlign: 'center',
		width: '100%',
	},
	homePage: {
		alignContent: 'center',
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		marginBottom: { lg: '7rem', sm: '5rem', xs: '4rem' },
	},
	lowerContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		marginTop: {
			lg: '108px',
			sm: '66px',
			xs: '57px',
		},
		marginBottom: {
			lg: '108px',
			sm: '66px',
			xs: '57px',
		},
	},
	spacer: {
		flexGrow: '0',
		width: '10rem',
	},
}
